import * as ScrollUtil from '../utils/scrolling';

/**
 * Form component
 *
 * Funktionen für Formulare.
 */

/**
 * Eine input-active Klasse wird hinzugefügt, sobald ein Input-Feld fokussiert
 * wird oder einen Wert hat.
 * @param {string|Node[]} selectorOrNodes
 */
function steerLabels(selectorOrNodes = '.widget-text input, .widget-textarea textarea') {
    let nodes = typeof selectorOrNodes == 'string' ? document.querySelectorAll(selectorOrNodes) : selectorOrNodes;

    nodes.forEach((input) => {
        // input.classList.add('steering');

        // Remove active class from label on blur if input is empty
        input.addEventListener('blur', function () {
            if (this.value === '') {
                this.parentNode.querySelector('label').classList.remove('input-active');
            }
        });

        // Add active class to label on focus
        input.addEventListener('focus', function () {
            this.parentNode.querySelector('label').classList.add('input-active');
        });

        // Add active class to label on page load if input is not empty
        if (input.value !== '') {
            input.parentNode?.querySelector('label')?.classList.add('input-active');
        }
    });
}

/**
 * Ensure script will work on input Fields after Ajax reload
 *
 * @param {string} selector
 */
function ajaxFormSteerLabels(selector = '.ce_form') {
    let ajaxForms = [...document.querySelectorAll(selector)].filter((el) => !!el.querySelector('[data-ajax-form]'));

    ajaxForms.forEach((ce_form) => {
        let observedWrapper = ce_form.querySelector('form').parentElement;

        // Options for the observer (which mutations to observe)
        const config = { childList: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    steerLabels(observedWrapper.querySelectorAll('.widget-text input, .widget-textarea textarea'));
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(observedWrapper, config);
    });
}

/**
 * Wenn Formular-Fehler auf der Seite sind, wird automatisch zum ersten gescrollt
 */
function scrollToErrors() {
    const firstError = document.querySelector('.error');

    ScrollUtil.scrollToTarget(firstError, -15);
}

document.addEventListener('DOMContentLoaded', () => {
    scrollToErrors();
    // Initial steer labels - do not delete
    steerLabels();
    // Steer Labels after Form reload
    ajaxFormSteerLabels();
});
